import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { colors } from "@/theme";

function FullScreenSpinner() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.surface }}>
      <div className="yo-spinner" />
    </div>
  );
}

export function ProtectedRoute({ roles }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.role) return <Navigate to="/complete-profile" replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "driver" ? "/pending" : "/board";
    return <Navigate to={home} replace />;
  }
  return <Outlet />;
}

export { FullScreenSpinner };
